var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-items"},[_c('section1',{staticClass:"item"}),_c('section2',{staticClass:"item"}),_c('section3',{staticClass:"item"}),_c('section4',{staticClass:"item"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }